import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { UploadService } from "../../../../infrastructure/upload/upload-service";
import { Logger } from "../../../../infrastructure/logger";
import mime from "mime";
import { MediaRepository } from "app/js/src/domain/media-repository";
import { UI } from "app/js/src/services/ui.service";
@Component({
  selector: "icn-drag-public-media",
  templateUrl: "drag-public-media.component.html",
  styleUrls: ["drag-public-media.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class.empty]": "!(isUploading() || hasMedia())",
    "[class.uploading]": "isUploading()",
    "[class.has-media]": "hasMedia()",
    "[class.is-video]": "hasMedia() && mediaIsVideo()",
  },
})
export class DragPublicMediaComponent implements OnInit, OnChanges {
  @Input()
  media: string;

  @Output()
  mediaChange = new EventEmitter<{ url: string; isVideo: boolean }>();

  @ViewChild("videoElm") private _videoElm: ElementRef;

  dragging = false;
  uploading = false;
  mimetype: string = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private uploadService: UploadService,
    private logger: Logger,
  ) {}

  ngOnInit(): void {
    this.parseMimetype(this.media);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.uploading = false;
  }

  hasMedia() {
    return !!this.media;
  }

  mediaIsVideo() {
    return this.mimetype && this.mimetype.startsWith("video/");
  }

  isUploading() {
    return this.uploading;
  }

  onDrop(e) {
    if (e.dataTransfer.files.length === 0) {
      return;
    }

    this.dragging = false;
    this.changeDetectorRef.markForCheck();
    e.preventDefault();

    this.uploadMedia(e.dataTransfer.files[0]);
  }

  onInputFileChange(e) {
    if (e.target.files.length === 0) {
      return;
    }

    this.uploadMedia(e.target.files[0]);
    e.target.value = "";
  }

  uploadMedia(file: File) {
    if (this.uploading) {
      return;
    }
    this.uploading = true;
    this.setMedia(undefined);
    this.changeDetectorRef.markForCheck();
    this.uploadService
      .uploadSmallFile(file)
      .then((url) => {
        this.parseMimetype(url);
        this.analyzeMedia(url);
        this.changeDetectorRef.markForCheck();
      })
      .catch((err) => {
        this.logger.warn("Could not upload file. Error: " + err);
        this.uploading = false;
        this.changeDetectorRef.markForCheck();
      });
  }

  onDragEnter() {
    this.dragging = true;
  }

  onDragLeave() {
    this.dragging = false;
  }

  setMedia(val: string) {
    this.media = val;
    this.parseMimetype(val);
  }
  deleteMedia() {
    this.mimetype = undefined;
    this.mediaChange.emit({ url: undefined, isVideo: false });
  }

  analyzeMedia(val: string) {
    this.mediaChange.emit({ url: val, isVideo: this.mediaIsVideo() });
  }

  parseMimetype(val: any) {
    this.mimetype = val ? mime.getType(val) : null;
  }

  playMedia() {
    this._videoElm.nativeElement.play();
  }
}
